export const links = {
  docs: {
    eMode: 'https://docs.spark.fi/user-guides/using-sparklend/e-mode',
    isolationMode: 'https://docs.spark.fi/user-guides/using-sparklend/#isolation-mode',
    siloedMode: 'https://docs.spark.fi/user-guides/using-sparklend/#supply-and-borrow-caps',
    isolationModeBorrowingPower: 'https://docs.spark.fi/user-guides/using-sparklend/isolation-mode',
    supplyBorrowCaps: 'https://docs.spark.fi/user-guides/using-sparklend/#supply-and-borrow-caps',
    healthFactor: 'https://docs.spark.fi/user-guides/using-sparklend/borrowing-assets#what-is-the-health-factor',
    supplying: 'https://docs.spark.fi/user-guides/using-sparklend/depositing-assets#how-much-will-i-earn',
    borrowing: 'https://docs.spark.fi/user-guides/using-sparklend/borrowing-assets#how-much-will-i-pay-in-interest',
    sparkAirdrop: 'https://docs.spark.fi/governance/spk-token',
    farmingRewards: 'https://docs.spark.fi/user-guides/farming-rewards',
    savings: {
      upgradeSdai: 'https://docs.spark.fi/user-guides/upgrading-to-usds-and-susds/upgrading-to-susds',
      newSavings: 'https://docs.spark.fi/user-guides/upgrading-to-usds-and-susds',
      susds: 'https://docs.spark.fi/user-guides/earning-savings/susds',
      susdc: 'https://docs.spark.fi/user-guides/earning-savings/susdc',
      sdai: 'https://docs.spark.fi/user-guides/earning-savings/sdai',
      withdrawSavings: 'https://docs.spark.fi/user-guides/earning-savings/#withdraw-savings',
      sparkPSM: 'https://docs.spark.fi/user-guides/spark-liquidity-layer/#cross-chain-liquidity-using-spark-psm',
      gnosisSdai: 'https://docs.spark.fi/user-guides/earning-savings/sdai#savings-xdai-on-gnosis-chain',
    },
    sparkRewards: 'https://docs.spark.fi/rewards',
    governance: 'https://docs.spark.fi/governance',
    // @todo: spk staking - replace with proper docs link
    spkStaking: 'https://docs.spark.fi/spk-staking',
  },
  snapshot: {
    sparkSpace: 'https://snapshot.box/#/s:sparkfi.eth',
    proposals: 'https://snapshot.box/#/s:sparkfi.eth/proposals',
  },
  aaveTechnicalPaper: 'https://github.com/aave/aave-v3-core/blob/master/techpaper/Aave_V3_Technical_Paper.pdf',
  termsOfUse: 'https://spark.fi/terms-of-use',
  privacyPolicy: 'https://spark.fi/privacy-policy',
  github: 'https://github.com/sparkdotfi/spark-app',
  skyInfoSavingsDashboard: 'https://info.sky.money/savings',
} as const
